//#region src/variants/variants_pagination.js
var variants_pagination_default = {
	default: { props: { totalPages: { initialValue: 25 } } },
	"max visible": { props: {
		totalPages: { initialValue: 12 },
		maxVisible: { initialValue: 3 }
	} },
	"active page": { props: {
		totalPages: { initialValue: 13 },
		activePage: { initialValue: 5 }
	} }
};
//#endregion
export { variants_pagination_default as default };

//# sourceMappingURL=variants_pagination.js.map